<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>REGISTRO DE CONDUCTORES</strong></h2>
    </div>

    <div class="d-flex justify-content-between mb-3">
      <button v-if="!isFormVisible" @click="showForm" class="btn btn-success">
        <i class="bi bi-person-fill-add"></i> Agregar Conductor
      </button>
      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Celular</th>
            <th>Correo</th>
            <th>Num. Licencia</th>
            <th>Tipo</th>
            <th>Fecha Vig. Licencia</th>
            <th>Disponibilidad</th>
            <th>Acciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="conductor in paginatedConductores" :key="conductor.Id_conductor">
            <td>{{ conductor.Id_conductor }}</td>
            <td>{{ conductor.Nombre }}</td>
            <td>{{ conductor.Celular }}</td>
            <td>{{ conductor.Correo }}</td>
            <td>{{ conductor.Licencia }}</td>
            <td>{{ conductor.Tipo }}</td>
            <td>{{ conductor.Fecha_vigencia }}</td>
            <td>{{ conductor.Disponibilidad }}</td>
            <td>
              <button @click="editConductor(conductor)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button
                @click="deleteConductor(conductor.Id_conductor)"
                class="btn btn-link1"
              >
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">
            Siguiente
          </button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container">
      <h3>{{ isEditing ? "Editar Conductor" : "Agregar Conductor" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input
            v-model="conductor.Nombre"
            type="text"
            id="nombre"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="celular">Celular</label>
          <input
            v-model="conductor.Celular"
            type="text"
            id="celular"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="correo">Correo</label>
          <input
            v-model="conductor.Correo"
            type="email"
            id="correo"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="licencia">Num. Licencia</label>
          <input
            v-model="conductor.Licencia"
            type="text"
            id="licencia"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="tipo">Tipo</label>
          <select v-model="conductor.Tipo" id="tipo" class="form-control" required>
            <option value="tipo a">Tipo a</option>
            <option value="tipo b">Tipo b</option>
            <option value="tipo c">Tipo c</option>
            <option value="tipo d">Tipo d</option>
          </select>
        </div>
        <div class="form-group">
          <label for="fecha_vigencia">Fecha Vigencia Licencia</label>
          <input
            v-model="conductor.Fecha_vigencia"
            type="date"
            id="fecha_vigencia"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <label for="disponibilidad">Disponibilidad</label>
          <select
            v-model="conductor.Disponibilidad"
            id="disponibilidad"
            class="form-control"
            required
          >
            <option value="Disponible">Disponible</option>
            <option value="No Disponible">No Disponible</option>
          </select>
        </div>
        <p></p>
        <button type="submit" class="btn btn-primary me-2">
          {{ isEditing ? "Actualizar" : "Guardar" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">
          Cancelar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data() {
    return {
      lista_conductores: [],
      conductor: {
        Id_conductor: null,
        Nombre: "",
        Celular: "",
        Correo: "",
        Licencia: "",
        Tipo: "",
        Fecha_vigencia: "",
        Disponibilidad: "",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredConductores() {
      return this.lista_conductores.filter((conductor) => {
        const searchString = `${conductor.Id_conductor} ${conductor.Nombre} ${conductor.Celular} ${conductor.Correo} ${conductor.Licencia} ${conductor.Tipo} ${conductor.Disponibilidad}`.toLowerCase();
        return searchString.includes(this.searchQuery.toLowerCase());
      });
    },
    paginatedConductores() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredConductores.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.filteredConductores.length / this.itemsPerPage);
    },
  },
  methods: {
    getConductores() {
      fetch(
        this.$backendUrl+ "/index.php/conductores/lista_completa"
      )
        .then((response) => response.json())
        .then((data) => {
          this.lista_conductores = data;
        })
        .catch((error) => {
          Swal.fire("Error", "Error al obtener los conductores.", "error");
          console.error("Error al obtener los conductores:", error);
        });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },
    editConductor(conductor) {
      this.isEditing = true;
      this.isFormVisible = true;
      this.conductor = { ...conductor };
    },
    deleteConductor(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(
            this.$backendUrl+ "/index.php/conductores/borrar",
            {
              method: "POST",
              body: JSON.stringify({ Id_conductor: id }),
              headers: { "Content-Type": "application/json" },
            }
          )
            .then(() => {
              this.getConductores();
              Swal.fire("Eliminado", "El conductor ha sido eliminado.", "success");
            })
            .catch((error) => {
              Swal.fire("Error", "Error al eliminar conductor.", "error");
              console.error("Error al eliminar conductor:", error);
            });
        }
      });
    },
    submitForm() {
      fetch(
       this.$backendUrl+ "/index.php/conductores/insertar",
        {
          method: "POST",
          body: JSON.stringify(this.conductor),
          headers: { "Content-Type": "application/json" },
        }
      )
        .then(() => {
          this.getConductores();
          this.cancelForm();
          Swal.fire("Éxito", "Conductor agregado correctamente.", "success");
        })
        .catch((error) => {
          Swal.fire("Error", "Error al agregar conductor.", "error");
          console.error("Error al agregar conductor:", error);
        });
    },
    submitEditForm() {
      fetch(
        this.$backendUrl+ "/index.php/conductores/actualizar",
        {
          method: "POST",
          body: JSON.stringify(this.conductor),
          headers: { "Content-Type": "application/json" },
        }
      )
        .then(() => {
          this.getConductores();
          this.cancelForm();
          Swal.fire("Éxito", "Conductor actualizado correctamente.", "success");
        })
        .catch((error) => {
          Swal.fire("Error", "Error al actualizar conductor.", "error");
          console.error("Error al actualizar conductor:", error);
        });
    },
    cancelForm() {
      this.isFormVisible = false;
      this.isEditing = false;
      this.resetForm();
    },
    resetForm() {
      this.conductor = {
        Id_conductor: null,
        Nombre: "",
        Celular: "",
        Correo: "",
        Licencia: "",
        Tipo: "",
        Fecha_vigencia: "",
        Disponibilidad: "",
      };
    },
  },
  mounted() {
    this.getConductores();
  },
};
</script>


<style scoped>
.table-container {
  overflow: auto;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349; 
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; 
}

.btn-link {
  color: #2fc1f6;
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-right: 10px;
  align-content: center;
}

.btn-link:hover {
  color: #ce13a2;
}

.btn-link1 {
  color: red; 
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-left: 10px;
}
</style>
